export function DemoStokeWidget() {
  return (
    <iframe
      src="http://localhost:5173/widget.html?shop=mz-rentals-mmbdgdqe"
      title="DemoStoke Booking Widget"
      style={{ width: "100%", minHeight: 760, border: 0, display: "block" }}
    />
  );
}
